/**
 * Comprime una foto en el navegador antes de guardarla.
 *
 * Los tickets se guardan como texto (data URL) dentro de Firestore, que limita
 * cada documento a 1 MB. Una foto del móvil pesa 3-5 MB: se reduce a 1600 px
 * por el lado largo y se baja la calidad JPEG hasta que quepa holgada. Un
 * ticket sigue leyéndose bien a ese tamaño.
 */
export const LIMITE_TICKET = 700_000; // caracteres del data URL (~520 KB de imagen)

const cargarImagen = (file: File) => new Promise<HTMLImageElement>((ok, mal) => {
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => { URL.revokeObjectURL(url); ok(img); };
  img.onerror = () => { URL.revokeObjectURL(url); mal(new Error('No se pudo leer la imagen')); };
  img.src = url;
});

export async function comprimirImagen(file: File, ladoMax = 1600): Promise<string> {
  if (!file.type.startsWith('image/')) throw new Error('El archivo no es una imagen.');
  const img = await cargarImagen(file);

  let lado = ladoMax;
  for (let intento = 0; intento < 6; intento++) {
    const escala = Math.min(1, lado / Math.max(img.width, img.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(img.width * escala);
    canvas.height = Math.round(img.height * escala);
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('El navegador no permite procesar imágenes.');
    // Fondo blanco: un PNG con transparencia saldría negro en JPEG
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

    for (const calidad of [0.75, 0.6, 0.45]) {
      const dataUrl = canvas.toDataURL('image/jpeg', calidad);
      if (dataUrl.length <= LIMITE_TICKET) return dataUrl;
    }
    lado = Math.round(lado * 0.75);
  }
  throw new Error('La imagen es demasiado grande incluso comprimida.');
}
